import { useMemo } from 'react';

import { XAxis } from '../../Axis/XAxis/index';
import { TickText } from '../../Axis/index';
import ChartDateFormatter from '../../ChartDateFormatter';

export const useDateAxisElementsMemo = ({
  dateAxis,
  getCategoryPeriod,
  compareMode,
  xAxisScale,
}) => {
  return useMemo(() => {
    if (dateAxis) {
      const { template, compareDisabled = false, minTickGap } = dateAxis;
      return (
        <XAxis
          scale={xAxisScale}
          dataKey={'category'}
          minTickGap={minTickGap}
          tick={({ payload, ...tickTextProps }) => {
            const [base, compared] = getCategoryPeriod(payload.value);
            return (
              <TickText {...tickTextProps}>
                <ChartDateFormatter
                  base={base}
                  compared={compared}
                  template={template}
                  compareMode={compareDisabled ? false : compareMode}
                />
              </TickText>
            );
          }}
        />
      );
    }
    return null;
  }, [getCategoryPeriod, compareMode, dateAxis]);
};
